module.exports = __webpack_public_path__ + "static/img/tb.4b4b761b.png";